import api from "../axiosIntercepture";

export const getTempUserDetails = async () => {
    try {
        const response = await api.post("/tenant/revision/latest", {
        });
        return response.data?.data ;
    } catch (err) {
        console.error("Login failed:", err);
        throw err; // Re-throw the error for further handling
    }
}

export const getTempUserDetailsById = async (id) => {
    try {
        const response = await api.post(`/tenant/revision/latest/${id}`, {
        });
        return response.data?.data ;
    } catch (err) {
        console.error("Login failed:", err);
        throw err; // Re-throw the error for further handling
    }
}

// Fetch editable field names from feedback API
export const getFeedbackFieldNames = async (tenantId) => {
    try {
        const response = await api.post(
            "/tenant/revision/feedback",
            { tenantId }
        );
        const fieldReviews = response.data?.data?.fieldReviews || response.data?.fieldReviews || [];
        return fieldReviews.map(f => f.fieldPath);
    } catch (err) {
        console.error("Failed to fetch feedback field names:", err);
        throw err;
    }
};

// Submit resubmission with only changed fields
export const submitResubmit = async (tenantId, submittedData) => {
    try {
        const response = await api.post(
            "/tenant/revision/resubmit",
            { tenantId, submittedData }
        );
        return response.data;
    } catch (err) {
        console.error("Failed to resubmit:", err);
        throw err;
    }
};